/**
 * The site chrome (the top bar) shows on every page except a table in play: a local or online game, or a replay,
 * which fill the screen. The table view switches it off while it is mounted.
 */
import { signal } from '@preact/signals';
import { useLayoutEffect } from 'preact/hooks';

/** True while a table view fills the screen. */
export const immersive = signal(false);

/** Hides the top bar for as long as the calling component is mounted (before the first paint). */
export function useImmersive(): void {
  useLayoutEffect(() => {
    immersive.value = true;
    return () => {
      immersive.value = false;
    };
  }, []);
}
